/* 🤖 this file was generated by svg-to-ts */
export const mgcIconChat3CuteFi: {
  name: 'chat-3-cute-fi';
  data: string;
} = {
  name: 'chat-3-cute-fi',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M11.02 3.045c-1.788.151-3.55.732-5 1.649-1.173.742-2.253 1.821-2.916 2.914a7.437 7.437 0 0 0-.032 7.712 7.87 7.87 0 0 0 1.286 1.644c.492.493.818.771 1.305 1.109l.243.169.168.51c.404 1.223.838 1.741 1.634 1.948.672.175 1.234.004 2.092-.637.231-.172.323-.22.4-.204.554.113 1.893.165 2.64.104 2.732-.224 5.038-1.237 6.784-2.98 1.376-1.373 2.134-2.917 2.334-4.751.169-1.553-.217-3.233-1.062-4.624-.663-1.093-1.743-2.172-2.916-2.914-1.994-1.261-4.508-1.857-6.96-1.649"/></svg>`
};
